import { Link } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { ILoungeInfo } from "../../../../api/api";
import {
  isLikeLoadingState,
  isOpenShareState,
  likeCountState
} from "../../../../atoms/atom";
import { redirectURL } from "../../../../utils/CommonFunc";
import Share from "../../Share/Share";
import "../pageHeader/PageShortHeader.scss";
import { useTranslation } from "react-i18next";
import { isLauncherState } from "../../../../atoms/userInfoAtom";
interface IProps {
  len: string | undefined;
  data: ILoungeInfo;
  LikeOnOff: string;
  getLikeBoard: () => void;
}

function PageShortHeader(props: IProps) {
  const { t } = useTranslation();
  const likeCount = useRecoilValue(likeCountState);
  const setIsOpenShare = useSetRecoilState(isOpenShareState);
  const isLikeLoading = useRecoilValue(isLikeLoadingState);
  const { len, data, LikeOnOff, getLikeBoard } = props;
  const handleShare = (e: React.MouseEvent) => {
    setIsOpenShare((isOpenShare) => !isOpenShare);
  };
  const isLauncher = useRecoilValue(isLauncherState);

  return (
    <div className={`page-header ${len}`}>
      <div className="row-w">
        <div className="scroll-header">
          <div className="scroll-header-inner left">
            <img
              className="thumb-img"
              src={data?.data.top_thumb_image_url}
              alt={`${data?.data.service_code} thumb-img`}
            />
            <span className="gamename">{data?.data.title}</span>
          </div>
          <div className="small-cont">
            {/*홈페이지 버튼*/}
            <Link
              to="#"
              className="btns home"
              onClick={() =>
                redirectURL(data?.data.web_url, "_self", isLauncher)
              }
              title={t("homepage")}
            >
              <span className="icon home" />
            </Link>
            {/* 사전예약/이벤트 버튼*/}
            {data?.data.pre_regist_url === null ? null : (
              <Link
                to="#"
                className="btns gamepad"
                onClick={() =>
                  redirectURL(data?.data.web_url, "_self", isLauncher)
                }
                title={t("event")}
              >
                <span className="icon gamepad" />
              </Link>
            )}

            {/*좋아요*/}
            <Link
              to="#"
              className={`btns thumb ${LikeOnOff}`}
              onClick={getLikeBoard}
              title={t("like")}
            >
              <span className="icon thumb" />
              {!isLikeLoading ? (
                likeCount.toLocaleString()
              ) : (
                <span className="fa fa-solid fa-circle-notch fa-spin" />
              )}
            </Link>

            {/*쉐어 버튼*/}
            <Link
              className="btns share"
              to="#"
              onClick={(e) => handleShare(e)}
              title={t("share")}
            />
            <Share data={data} len={len} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageShortHeader;
